import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(_Circle, { cx: "12.1", cy: "12.1", r: "1", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Dot";
const Dot = memo(themed(Icon));
export {
  Dot
};
//# sourceMappingURL=dot.js.map
